import { TextLabel, Row, Col } from "../lib";
import { OnlineDot } from "./online-dot";

type Props = {
  value: boolean;
  loading?: boolean;
};

export function OnlineIndicator({ value, loading = false }: Props) {
  return (
    <Row.L>
      <TextLabel em>{value ? "ONLINE" : "OFFLINE"}</TextLabel>

      <Col ml="2">
        <OnlineDot value={value} loading={loading} />
      </Col>
    </Row.L>
  );
}
